module.exports = __webpack_public_path__ + "static/media/vardis-group.f53f26df.png";